import { render, staticRenderFns } from "./XolasTablePagination.vue?vue&type=template&id=4bd2cfb5"
import script from "./XolasTablePagination.vue?vue&type=script&lang=js"
export * from "./XolasTablePagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports